/**
 * Component to render the gigya ratings
 */
import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get';
import Help from '@nerdwallet/react-icon/gizmo/Help';
import Link from '@nerdwallet/react-link';
import Popover from '@nerdwallet/react-popover';
import StarRating from '@nerdwallet/react-star-rating';
import { connect } from 'react-redux';

var GigyaRating = function GigyaRating(props) {
  // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
  var rating = get(props.gigya, "ratings[".concat(props.streamID, "]"));
  var overall = get(rating, 'avgRatings._overall', 0);
  var ratingCount = get(rating, 'ratingCount');
  var formattedRatingCount = // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
  ratingCount !== undefined && props.formatRatingCount(ratingCount); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

  var href = props.formatHref(props.streamID);
  var title = rating ? "".concat(overall, " / 5.0") : 'Loading...';

  if (!rating) {
    return React.createElement("div", null);
  }

  return React.createElement("div", {
    className: "gigya-rating",
    title: title,
    alt: title
  }, props.shouldShowTabDesign ? React.createElement("div", {
    className: "overall-rating-number"
  }, overall) : null, React.createElement(StarRating, {
    rating: overall
  }), props.enableHref ? React.createElement(Link, {
    className: "gigya-rating__reviews-link",
    href: href
  }, formattedRatingCount) : React.createElement("span", {
    className: "gigya-rating__reviews-link"
  }, formattedRatingCount), props.popoverContent ? React.createElement(Popover, {
    className: "gigya-rating__reviews-tooltip",
    type: ['hover', 'click'] // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    ,
    popoverContent: props.popoverContent
  }, React.createElement(Help, {
    textAligned: true
  })) : null);
};

GigyaRating.defaultProps = {
  enableHref: true,
  formatRatingCount: function formatRatingCount(ratingCount) {
    return "(".concat(ratingCount, ")");
  },
  formatHref: function formatHref(streamID) {
    return "/card-details/card-name/".concat(streamID, "#cardholder-reviews");
  },
  shouldShowTabDesign: false
};
GigyaRating.propTypes = {
  streamID: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  gigya: PropTypes.object,
  enableHref: PropTypes.bool,
  formatHref: PropTypes.func,
  formatRatingCount: PropTypes.func,
  shouldShowTabDesign: PropTypes.bool,
  popoverContent: PropTypes.node
};
export default connect(function (state) {
  return {
    gigya: state.gigya
  };
})(GigyaRating);